import React, { useState } from "react";
import "./auth.css";
import { Btn, ErrorComp, FormCheckbox, FormInput, SuccessComp } from "../../utils/utils";
import login from "../../assets/login.png";
import { Link, useNavigate } from "react-router-dom";
import { LoginPost } from "../../api/api";

const LoginComp = () => {
  const url = "auth/login/";
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  // const [isChecked, setIsChecked] = useState(true);
  const [successMsg, setSuccessMsg] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [data, setData] = useState({
    email: "",
    password: "",
  });
  const [dataErr, setDataErr] = useState({
    email: "",
    password: "",
  });

  const dataChange = (e) => {
    const newData = { ...data };
    newData[e.target.id] = e.target.value;
    setData(newData);
    const newDataErr = { ...dataErr };
    newDataErr[e.target.id] = "";
    setDataErr(newDataErr);
    // console.log(newData);
  };

  const clickLogin = () => {
    setIsLoading(true);
    const credentials = `${data.email}:${data.password}`;
    const encoded = btoa(credentials); 
    LoginPost(url, encoded).then((res) => {
      // console.log(res);
      setSuccessMsg(res.message);
      localStorage.setItem("apk", JSON.stringify(res.data));
      setTimeout(() => {
        if(res?.data?.data?.accountType === "Agent"){
          navigate("/agent/overview");
        }
        if(res?.data?.data?.accountType === "Developer"){
          navigate("/dev_dash/dashboard");
        }
        setSuccessMsg("");
      }, 2000);
      setIsLoading(false);
    }).catch((err) => {
      // console.log(err.response);
      setErrMsg(err?.response?.data?.message);
      setTimeout(() => {
        setErrMsg("");
      }, 2000);
      for (let i = 0; i < err?.response?.data?.errors?.length; i++) {
        const fieldName = err?.response?.data?.errors[i].fieldName;
        const error = err?.response?.data?.errors[i].error;
        setDataErr((prevErrs) => ({
          ...prevErrs,
          [fieldName]: error,
        }));
      }
      setIsLoading(false);
    })
  };

  return (
    <div className="sign-cont login-cont">
      <SuccessComp message={successMsg} />
      <ErrorComp message={errMsg} />
      <div className="sign-left">
        <h2>Welcome Back!</h2>
        <h3>Enter your details to get unlimited information</h3>
        <div className="sign-form">
          <FormInput
            type="email"
            label={"Email"}
            id={"email"}
            value={data.email}
            changeInput={dataChange}
            err={dataErr.email}
          />
          <FormInput
            label={"Password"}
            isPassword
            id={"password"}
            value={data.password}
            changeInput={dataChange}
            err={dataErr.password}
          />
          <div className="forgot-p">
            <div className="remember">
              <FormCheckbox />
              <p>Remember me</p>
            </div>
            <Link
              to={"/auth/forgot-password"}
              style={{ textDecoration: "none" }}
            >
              <p>
                <span>Forgot your password?</span>
              </p>
            </Link>
          </div>
          <div className="sign-btn_cont">
            <Btn
              btnClass={"home-btn sign-btn"}
              btnText={"Sign in"}
              btnClick={clickLogin}
              loading={isLoading}
            />
          </div>
        </div>
        <p>
          Don't have an account?{" "}
          <Link to={"/auth/signup-opt"} style={{ textDecoration: "none" }}>
            <span>Sign up</span>
          </Link>
        </p>
      </div>
      <div className="sign-right">
        <img src={login} alt="login" />
      </div>
    </div>
  );
};

export default LoginComp;
